export function loadCourseCategoryList() {
  return {
    type: 'LOAD_COURSE_CATEGORY_LIST',
  };
}

export function loadCourseCategoryListCompletion(error, list) {
  return {
    type: 'LOAD_COURSE_CATEGORY_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadCourse(courseId) {
  return {
    type: 'LOAD_COURSE',
    courseId,
  };
}

export function loadCourseCompletion(courseId, error, data) {
  return {
    type: 'LOAD_COURSE_COMPLETION',
    courseId,
    error,
    data,
  };
}

export function loadCourseCategoryDetail(id) {
  return {
    type: 'LOAD_COURSE_CATEGORY_DETAIL',
    id,
  };
}

export function loadCourseCategoryDetailCompletion(id, error, data) {
  return {
    type: 'LOAD_COURSE_CATEGORY_DETAIL_COMPLETION',
    id,
    error,
    data,
  };
}
